export function resolveStripePublishableKey(environment = {}) {
  const value = environment.REACT_APP_STRIPE_PUBLISHABLE_KEY;
  const modeValue = environment.REACT_APP_STRIPE_MODE;
  const mode = typeof modeValue === 'string' ? modeValue.trim().toLowerCase() : '';
  if (!['test', 'live'].includes(mode)) {
    return {
      key: null,
      error: 'Stripe checkout mode is not configured. Set REACT_APP_STRIPE_MODE to test or live.',
    };
  }
  const key = typeof value === 'string' ? value.trim() : '';
  if (!key) {
    return {
      key: null,
      error: 'Stripe checkout is not configured. Set REACT_APP_STRIPE_PUBLISHABLE_KEY.',
    };
  }
  if (!/^pk_(?:test|live)_[A-Za-z0-9]+$/.test(key)) {
    return {
      key: null,
      error: 'REACT_APP_STRIPE_PUBLISHABLE_KEY is not a valid Stripe publishable key.',
    };
  }
  if (!key.startsWith(`pk_${mode}_`)) {
    return {
      key: null,
      error: `The Stripe publishable key does not match configured ${mode} mode.`,
    };
  }
  return { key, mode, error: null };
}
